var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('horizontal-nav',{attrs:{"items":_vm.items,"show_display":false,"set_view":""}}),_c('casos-por-dia')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }